import { z } from 'zod'
import { lessonPlanSchema } from './lessonPlanSchema'

const bookSchema = z.object({
  id: z.string().regex(/^[a-fA-F0-9]{24}$/),
  title: z.string(),
  cover: z
    .instanceof(FileList)
    .transform((FileList) => FileList?.[0])
    .refine((file) => !file || file.type.startsWith('image/'))
    .transform((file) => file || undefined),
  audience: z.enum(['Instructor', 'Participant', 'Public']),
  language: z.enum(['PT', 'EN', 'ES']),
  numberOfChapters: z.coerce.number(),
  description: z.string(),
  readingLink: z.string(),
  lessonPlans: z.array(lessonPlanSchema),
  createdAt: z.date(),
  updatedAt: z.date(),
  deletedAt: z.date()
})

export const createBookSchema = bookSchema.omit({
  id: true,
  lessonPlans: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true
})

export const updateBookSchema = createBookSchema.partial()

export const filterBooksStatisticsSchema = z.object({
  startDate: z.string(),
  endDate: z.string(),
  bookId: z.string().transform((val) => {
    if (val === '' || !val) {
      return null
    }

    return val
  })
})
